import { NgModule } from '@angular/core';
import { TenantRelationColoredLabelComponent } from '@modules/bcm/@shared/components/tenant-relation-colored-label/tenant-relation-colored-label.component';
import { NgForOf, NgIf } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import {BcmDirectivesModule} from '@modules/bcm/@core/directives/bcm-directives.module';
import { TranslationModule } from '@core/translation/translation.module';

@NgModule({
    declarations: [TenantRelationColoredLabelComponent],
    imports: [
        NgIf,
        NgForOf,
        MatTooltipModule,
        BcmDirectivesModule,
        TranslationModule
    ],
    exports: [TenantRelationColoredLabelComponent]
})
export class TenantRelationColoredLabelModule  {}
